export enum ConfirmationResult {
  Rejected,
  Accepted
}

export class ConfirmationMetadata {
  id?: string;
  key?: string;
  data?: any;
  header?: string;
  message: string;
  icon?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  acceptIcon? = 'pi pi-check';
  rejectIcon? = 'pi pi-times';
  hideCancel?: boolean;
  result?: ConfirmationResult;

  public constructor(init?: Partial<ConfirmationMetadata>) {
    Object.assign(this, init);
  }
}
